const fens = [
  "8/1prb1k1p/1R4p1/8/2P5/3B1P2/5KPP/8 w - - 4 38",
  "r4rk1/4qppp/2p1pn2/pb2N3/1n1PP3/1Q4P1/3N1PBP/R1R3K1 b - - 4 18",
  "6k1/6p1/4bp1p/4p3/p5P1/P3RP2/1NK4P/r7 w - - 1 39",
  "rn2k2r/pbp5/1p1ppq1p/5pp1/2PPn3/1QPBPNB1/P4PPP/2R1K2R b Kkq - 3 13",
  "5rk1/6pp/1q6/p2p1pQ1/1n3N2/6P1/2r2P1P/R4RK1 w - - 6 34",
  "5bk1/1q1n1p1p/1pN3p1/1NpPp3/2P1P3/7P/5PP1/Q5K1 b - - 7 33",
  "2rqk2r/1p1nbppp/p2pbn2/4p1B1/4P3/2N2N2/PPPQBPPP/R4RK1 w k - 8 11",
  "1r1qk2r/pbp1bppp/1p2pn2/n7/P1pPP3/5NP1/1PQN1PBP/R1BR2K1 b k - 2 11",
];

export default fens;
